import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";

import { useModalContext } from "@/components/General/Modal/context/modal.context";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    className?: string;
};

export const CloseButton = ({ className }: Props) => {
    const { t } = useGranite();
    const { closable, cancelButtonText, onClose, onCancel } = useModalContext();

    const handleOnCloseClick = () => {
        onCancel?.();
        onClose();
    };

    if (!closable) return null;

    return (
        <Button
            color={"link"}
            type={"button"}
            className={cn("tw:px-0", className)}
            onClick={handleOnCloseClick}
        >
            <i className="las la-angle-left" />
            {cancelButtonText || t("general.button.cancel")}
        </Button>
    );
};
